"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FlaechenauswertungPage;
const jsx_runtime_1 = require("react/jsx-runtime");
const ReportDisplay_1 = __importDefault(require("@/components/pbi/ReportDisplay"));
const reportConstants_1 = require("@/config/reportConstants");
const powerbiUtils_1 = require("@/utils/powerbiUtils");
function FlaechenauswertungPage() {
    return ((0, jsx_runtime_1.jsx)(ReportDisplay_1.default, { className: "embed-report", reportCode: reportConstants_1.RC_FLAECHENAUSWERTUNG, onButtonClicked: powerbiUtils_1.handleFlaechenButtonClicked }));
}
